
    var riot = require('riot')
    riot.tag2('kf-payjp', '', '', '', function(opts) {
    const ON_CREATED_NAME = `__payjpOnCreated_${Math.random() * 1e16}__`;
    const ON_FAILED_NAME = `__payjpOnFailed_${Math.random() * 1e16}__`;
    const query = riot.util.dom.$;

    this.getToken = () => {
      return query('input[name="payjp-token"]', this.root) ?
        query('input[name="payjp-token"]', this.root).value : null;
    };

    this.on('mount', () => {
      window[ON_CREATED_NAME] = opts.oncreated;
      window[ON_FAILED_NAME] = opts.onfailed;

      const scriptEl = document.createElement('script');

      const attrs = {
        type: 'text/javascript',
        src: 'https://checkout.pay.jp/',
        class: 'payjp-button',
        'data-key': opts.apiKey,
        'data-payjp': opts.clientId,
        'data-partial': !!opts.partial,
        'data-text': opts.text,
        'data-submit-text': opts.submitText,
        'data-token-name': opts.tokenName,
        'data-previous-token': opts.previousToken,
        'data-lang': opts.lang,
        'data-on-created': ON_CREATED_NAME,
        'data-on-failed': ON_FAILED_NAME,
        'data-name-placeholder': opts.namePlaceholder,
        'data-payjp-extra-attribute-email': '',
        'data-payjp-extra-attribute-phone': '',
        'data-payjp-three-d-secure': 'true',
        'data-payjp-three-d-secure-workflow': 'iframe',
      };
      for (const key in attrs) {
        if (attrs.hasOwnProperty(key)) {
          const value = attrs[key];
          if (value !== undefined) {
            scriptEl.setAttribute(key, value);
          }
        }
      }
      this.root.appendChild(scriptEl);
    });

    this.on('unmount', () => {
      window[ON_CREATED_NAME] = undefined;
      window[ON_FAILED_NAME] = undefined;
      window.PayjpCheckout = undefined;
      const payjpEl = query('#payjp-checkout-iframe').parentNode;
      payjpEl.parentNode.removeChild(payjpEl);
    });
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('kf-payjp')
    }
  }
  